export default "__VITE_ASSET__CzcQMHer__"